import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ProductService } from '../core/product.service';
import { productIds } from '../../globals';

@Injectable({ providedIn: 'root' })
export class CrmSkuAccessService {
  private readonly productService = inject(ProductService);

  readonly enableCustomObjects$: Observable<boolean> = this.productService.activeProducts$.pipe(
    map((products) => products.some((product) => product.productId === productIds.crmAi)),
    shareReplay({ refCount: true, bufferSize: 1 }),
  );
}

